import { createFileRoute } from "@tanstack/react-router"

import { AgentProfile } from "@/pages/AgentProfile"

export const Route = createFileRoute("/agent/$agentType")({
  component: AgentProfile,
})
